
import { SchedulerTask } from "../../classes"

const SchedulerTaskModule = {
  namespaced: true,
  state: {
    schedulerTask: null,
    schedulerTasks: null
  },
  mutations: {
    setSchedulerTask(state, data) {
      state.schedulerTask = data
    },
    setSchedulerTasks(state, data) {
      state.schedulerTasks = data
    }
  },
  actions: {
    async createSchedulerTask({ commit }, formData) {
      try {
        const data = await SchedulerTask.createSchedulerTask(formData);
        return data
      } catch (error) {
        throw error
      }
    },
    async updateSchedulerTask({ commit }, formData) {
      try {
        const data = await SchedulerTask.updateSchedulerTask(formData);
        return data
      } catch (error) {
        throw error
      }
    },
    async getSchedulerTasksByContract({ commit }, formData) {
      try {
        commit("setSchedulerTasks", null)
        const data = await SchedulerTask.getSchedulerTasksByContract(formData);
        commit("setSchedulerTasks", data)
        return data
      } catch (error) {
        throw error
      }
    },
    async getSchedulerTask({ commit }, id) {
      try {
        commit("setSchedulerTask", null)
        const data = await SchedulerTask.getSchedulerTask(id);
        commit("setSchedulerTask", data)
        return data
      } catch (error) {
        throw error
      }
    },
    async removeSchedulerTask({ commit }, id) {
      try {
        const data = await SchedulerTask.removeSchedulerTask(id);
        return data
      } catch (error) {
        throw error
      }
    },
    async activeSchedulerTask({ commit }, formData) {
      try {
        const data = await SchedulerTask.activeSchedulerTask(formData);
        return data
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    getSchedulerTask: (state) => {
      return state.schedulerTask
    },
    getSchedulerTasks: (state) => {
      return state.schedulerTasks
    }
  },
};
export default SchedulerTaskModule;
